import React, { createRef, useState } from "react";
import Button from "./../../../components/common/button";
import { colors } from "./../../../share/constants/enums";
import { Link, useNavigate } from "react-router-dom";
import Tick from "./../../../assets/icons/tick.svg";
import { Input as InputField, message } from "antd";
import { emailVerification, resendConfirmationCode } from "../../../api/auth";
const Otp = () => {
  const phone = localStorage.getItem("phone");
  const email = localStorage.getItem("email");

  const navigate = useNavigate();
  const inputRefs = Array(6)
    .fill(null)
    .map(() => createRef());

  const [inputValues, setInputValues] = useState(Array(6).fill(""));
  const [loader, setLoader] = useState(false);
  const handleInput = (index, event) => {
    const input = event.target;
    const inputValue = input.value;

    if (inputValue.length === 1 && index < inputRefs.length - 1) {
      inputRefs[index + 1].current.focus();
    }

    const newInputValues = [...inputValues];
    newInputValues[index] = inputValue;
    setInputValues(newInputValues);

    if (inputValue === "" && index > 0) {
      inputRefs[index - 1].current.focus();
    }
  };

  const handleSubmit = async () => {
    setLoader(true);
    const input = inputValues.join("");
    const payload = {
      email: email,
      code: input,
    };
    try {
      const res = await emailVerification(payload);
      if (res?.status) {
        message.success("Sent To The Admin For Verification");
        navigate("/thankyou");
      }
    } catch (error) {
    } finally {
      setLoader(false);
    }
  };

  const handleKeyDown = (index, event) => {
    const keyCode = event.keyCode || event.which;
    if ((keyCode < 48 || keyCode > 57) && keyCode !== 8) {
      event.preventDefault();
    } else if (
      keyCode === 8 &&
      index > 0 &&
      inputRefs[index].current.value === ""
    ) {
      inputRefs[index - 1].current.focus();
    }
  };

  const handleResendCode = async () => {
    const res = await resendConfirmationCode({ email: email });
    if (res?.status) {
      message.success("Sent");
    }
  };
  return (
    <>
      <div className="flex flex-col justify-center md:mt-14 space-y-1 items-center box-content h-50 w-32 p-4 border-4">
        <div>
          <img className="w-6" alt="yupup-logo" src={Tick} />
        </div>
        <div className="border 0px text-6x ">
          <p className="text-xl">Please verify your phone number</p>
        </div>
        <div className="label">
          <div className="a-verification-code ">
            <p className="font-normal text-wrapper">
              A verification code has been sent to your phone number
            </p>
            <p className="text-center">
              <strong>{phone}</strong>
            </p>
          </div>
        </div>
        <div className="flex flex-col items-center space-y-2">
          <div>
            <p className="mb-0">
              <strong>Enter the code sent to your phone number</strong>
            </p>
          </div>
          <div className="grid grid-cols-6 gap-3 ">
            {inputRefs.map((ref, index) => (
              <InputField
                ref={ref}
                key={index}
                className="w-5 h-6 bg-inputFieldGrey text-center text-lg"
                placeholder=""
                maxLength={1}
                onKeyDown={(event) => handleKeyDown(index, event)}
                onInput={(event) => handleInput(index, event)}
              />
            ))}
          </div>
          <div
            onClick={handleResendCode}
            className="text-primaryPurple cursor-pointer"
          >
            Resend Code
          </div>
        </div>
        <div className="float-right bottom-left absolute bottom-3 right-3 ">
          <Link className="no-underline">
            <Button
              loading={loader}
              onClick={handleSubmit}
              title="Done"
              color={colors.primaryPurple}
              className="w-19 mt-10"
            />
          </Link>
        </div>
      </div>
    </>
  );
};

export default Otp;
